import { makeStyles, createStyles, Button, Dialog, IconButton } from '@material-ui/core';
import { useState, useContext, FC, ChangeEvent } from 'react';
import { FormContext, FormControlProps, registry } from '..';
import { PhotoCamera, AddPhotoAlternate, Close } from '@material-ui/icons';
import { grey } from '@material-ui/core/colors';
import { ImageImportControlDefinition, parseFieldIdentifier } from '../services';
import { delayedUploadImageActions } from '../../../../redux';
import React from 'react';
import Camera, { IMAGE_TYPES, FACING_MODES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import { useDispatch } from 'react-redux';
// var uuidv4 = require("uuid/v4");
import { v4 as uuidv4 } from 'uuid';
require('./ImageCapture.css');
export interface ImageImportProps extends FormControlProps<ImageImportControlDefinition> {
}
let cameraAvailable = false;
function checkCameraAvailable() {
  if (!navigator || !navigator.mediaDevices) {
    cameraAvailable = false;
    return;
  }
  navigator.mediaDevices
    .enumerateDevices()
    .then(function (e) {
      const t = e.find(function (e) {
        return e.kind === 'videoinput';
      });
      cameraAvailable = t !== undefined;
    })
    .catch(function () {
      return (cameraAvailable = false);
    });
}
checkCameraAvailable();
const useStyles = makeStyles(function (e) {
  return createStyles({
    root: { alignSelf: 'center' },
    toolbar: { backgroundColor: 'rgba(a,a,a,2)' },
    cameraBox: { height: '100%', width: '100%', overflow: 'hidden', backgroundColor: 'rgb(0,0,0)' },
    closeButton: { position: 'absolute', top: 0, left: e.spacing(3), color: grey[50] },
    imageWrapper: { width: '100%', height: '100%' },
    image: { display: 'block', marginLeft: 'auto', marginRight: 'auto', maxWidth: '100%', maxHeight: '100%', height: 'auto' },
    confirmBox: { position: 'absolute', width: '100%', bottom: 0, display: 'flex', height: '44px' },
    confirmButton: { flex: 1, backgroundColor: grey[900], opacity: 0.8, color: grey[50], borderRadius: 0, '&:hover': { backgroundColor: grey[600] } },
  });
});
export const ImageImport: FC<ImageImportProps> = function(props) {
  const t = props.definition;
  const classes = useStyles({});
  const [ isCameraOn, setIsCameraOn ] = useState(false);
  const [ isDisabled, setIsDisabled ] = useState(false);
  const [ isCameraAvailable, setIsCameraAvailable ] = useState(cameraAvailable);
  const [ uri, setURI ] = useState<string | undefined>(undefined);
  const { scope, evalID } = useContext(FormContext);
  const dispatch = useDispatch();

  function onCapture(uri: string) {
    // HACK: There is a slight delay between when the camera dialog appears and when the stream
    // is available.  If the stream is not available, then uri will be 'data:.'.  If this is passed
    // to setURI(), then the client will get errors that the stream isn't present, and the camera
    // control will be disposed before the stream can be closed.  The result is that an extra
    // video stream will remain active in the background.  Performing the check below will prevent
    // this from happening.  Instead, the camera dialog will ignore all capture attempts until
    // the stream is available.
    if (uri !== 'data:,') {
      setURI(uri);
    }
  }
  function onError(error: Error) {
    console.log(error);
    if (error.message.includes('device not found')) {
      cameraAvailable = false;
      setIsCameraAvailable(cameraAvailable);
      setIsCameraOn(false);
    }
  }
  function toggleCamera() {
    setIsCameraOn(!isCameraOn);
  }
  function onDialogClose(_: any, __?: string) {
    toggleCamera();
    setURI(undefined);
  }
  function onKeep() {
    dispatch(delayedUploadImageActions.request({ id: uuidv4(), uri: uri as string, scope: scope, evalID: evalID as string, path: '{' + parseFieldIdentifier(t.dataPath) + '/-}' }));
    toggleCamera();
    setURI(undefined);
  }
  function onDiscard() {
    setURI(undefined);
  }
  function onUpload(files: FileList | null) {
    if (!files) {
      return;
    }
    const reader = new FileReader();
    reader.onload = function () {
      dispatch(delayedUploadImageActions.request({ id: uuidv4(), uri: reader.result as string, scope: scope, evalID: evalID as string, path: '{' + parseFieldIdentifier(t.dataPath) + '/-}' }));
    };
    reader.readAsDataURL(files[0]);
  }
  function renderConfirm() {
    return (
      <div className = { classes.imageWrapper }>
        <img src = { '' + uri } className = { classes.image }></img>
        <div className = { classes.confirmBox }>
          <Button
            variant = { 'text' }
            component = { 'span' }
            onClick = { onDiscard }
            className = { classes.confirmButton }>
              Retake
            </Button>
          <Button
            variant = { 'text' }
            component = { 'span' }
            onClick = { onKeep }
            className = { classes.confirmButton }>
              Accept
            </Button>
        </div>
      </div>
    );
  }
  function renderCamera() {
    return (
      <div style = { { overflow: 'hidden' } }>
        <Camera
          onTakePhoto = { onCapture }
          onCameraError = { onError }
          idealResolution = { { width: 800, height: 600 } }
          imageType = { IMAGE_TYPES.JPG }
          isImageMirror = { false }
          isFullscreen = { true }
          idealFacingMode = { FACING_MODES.ENVIRONMENT }
          // on = { true }
          >
        </Camera>
      </div>
    );
  }
  function renderDialog() {
    const content = uri ? renderConfirm() : renderCamera();
    return (
      <Dialog
        aria-labelledby = { 'simple-dialog-title' }
        fullScreen = { true }
        onClose = { onDialogClose }
        open = { isCameraOn }
        onKeyDown = { function (e) {
          if (e.key === 'Enter' && uri) {
            onKeep();
          }
        } }>
        <div className = { classes.cameraBox }>
          { content }
          {/* typings */}
          <IconButton
            edge = { 'start' }
            color = { 'inherit' }
            aria-label = { 'close' }
            onClick = { onDialogClose }
            className = { classes.closeButton }
            size = { 'medium' }>
            <Close></Close>
          </IconButton>
        </div>
      </Dialog>
    );
  }
  function renderButtons() {
    const inputRef = React.createRef<HTMLInputElement>();

    return (
      <div className = { classes.root }>
        { isCameraAvailable &&
          <IconButton
            disabled = { isDisabled }
            onClick = { () => toggleCamera() }>
            <PhotoCamera></PhotoCamera>
          </IconButton>
        }
        <input
          accept = { 'image/*' }
          id = { 'upload-button' }
          type = { 'file' }
          onChange = { (e: ChangeEvent<HTMLInputElement>) => onUpload(e.target.files) }
          hidden = { true }
          ref = { inputRef }>
        </input>
        <IconButton
          disabled = { isDisabled }
          onClick = { () => inputRef?.current?.click() }>
          <AddPhotoAlternate></AddPhotoAlternate>
        </IconButton>
      </div>
    );
  }
  return uri || (isCameraOn && !isDisabled) ? renderDialog() : renderButtons();
};
registry.registerComponent('ImageImport', ImageImport);
